export default __webpack_public_path__ + "static/media/Calender_Icon.48c6d449.svg";